<template>
  <div>
    <!-- 操作 -->
    <div class="operate">
      <!--全选  -->
      <el-checkbox v-model="$parent.checked" @change="allChecked">
        {{ $t("message.allChecked") }}
      </el-checkbox>
      <!-- 追加商品 -->
      <el-button size="mini" type="primary" @click="addGoods" v-if="isAuth(600)">
        {{ $t("message.addProduct") }}
      </el-button>
      <!-- 退回临时保存 -->
      <el-button size="mini" type="primary" class="dark" @click="toPorderTemp">
        {{ $t("message.returnToTemporaryStorage") }}
      </el-button>
      <!-- 修改 -->
      <el-button size="mini" type="primary" class="secondary" @click="updatePorderNum" v-if="isAuth(236)">
        {{ $t("message.edit") }}
      </el-button>
      <!-- 打印清单 -->
      <el-button size="mini" type="primary" @click="printList" class="secondary">
        {{ $t("message.printList") }}
      </el-button>
      <!-- 一件新增M i C -->
      <el-button size="mini" type="primary" @click="batchAppendTagText" v-if="isAuth(232)"> 新增Made in China
      </el-button>

      <el-button size="mini" type="primary" @click="batchAppendTagPorder(4)" v-if="isAuth(232)"> 新增配送单后四位
      </el-button>

      <el-button size="mini" type="primary" @click="batchAppendTagPorder('')" v-if="isAuth(232)"> 新增完整配送单
      </el-button>
      <!--   编码-文本1 -->
      <el-button size="mini" type="primary" @click="batchGoodsNoCoverTextOne" v-if="isAuth(638)"> 编码-文本1
      </el-button>

      <!-- 批量修改条码格式 -->
      <el-button size="mini" type="primary" @click="batchModifyCodeType" v-if="isAuth(232)" class="primary"> 批量修改条码格式
      </el-button>
      <!-- 新增服务单 -->
      <el-button size="mini" type="success" @click="addServiceOrder" v-if="isAuth(768)">
        {{ $t("message.addServiceOrder") }}
      </el-button>
      <!-- 售中问题提出 -->
      <el-button size="mini" type="primary" @click="issueSubmissionDuringSale" v-if="isAuth(621)">
        {{ $t("message.issueSubmissionDuringSale") }}
      </el-button>
      <!-- 预设任务 -->
      <!-- <el-button size="mini" type="primary" @click="createPresetTask">
        {{ $t("message.presetTask") }}
      </el-button> -->
      <!-- 提交给配货 -->
      <el-button size="mini" type="primary" class="fr" @click="submitTranslate(0)" v-if="isAuth(237)">
        {{ detail.is_fba ? '提交给FBA' : $t("message.submitToDistribution") }}
      </el-button>
      <!-- 临时保存 -->
      <el-button size="mini" type="primary" class="fr" @click="submitTranslate(1)" v-if="isAuth(237)">
        {{ $t("message.temporaryStorage") }}
      </el-button>
      <!-- 标签匹配 -->
      <el-button size="mini" type="primary" class="fr" @click="tagMatching" v-if="isAuth(231)">
        {{ $t("message.tagMatching") }}
      </el-button>
      <!-- 配送单拆分 -->
      <el-button size="mini" type="success" class="fr" @click="distributionOrderSplit" v-if="isAuth(225)">
        {{ $t("message.distributionOrderSplitting") }}
      </el-button>
      <!-- 清空FBA数据 -->
      <el-button size="mini" type="primary" class="dark fr" @click="deleteMatchData" v-if="isAuth(230)">
        {{ $t("message.clearFBAData") }}
      </el-button>
      <!-- 新建标签 -->
      <el-button size="mini" type="primary" class="secondary fr" @click="labelNumberAdd" v-if="isAuth(232)">
        {{ $t("message.labelNumberAdd") }}
      </el-button>
      <!-- 撤回翻译 -->
      <el-button size="mini" type="primary" class="secondary fr" @click="isYEditing(0)">
        撤回翻译
      </el-button>
      <!-- 批量删除标签 -->
      <el-button size="mini" type="primary" class="dark fr" @click="deleteFbaSign">
        {{ $t("message.batchDeleteLabels") }}
      </el-button>
      <!-- 特殊客户标签上传 -->
      <el-button size="mini" type="primary" class="primary fr" @click="specialClientMatch"
        v-if="porder_sn.split('-')[1] == '1868'">
        {{ $t("message.uploadSpecialCustomerTags") }}
      </el-button>
      <!--列表  -->
      <div v-show="false">
        <printList ref="printList" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import printList from '../packing/printList'

export default {
  components: {
    printList,

  },
  props: {
    selectedList: { type: Array },
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.porderDetail.list,
      detail: (state) => state.porderDetail.detail,
    }),
  },
  created() {
    if (this.detail.status == 20 && this.detail.is_y_editing == 0) {
      this.$alert("开始翻译后，客户不能修改订单", "提示", {
        confirmButtonText: "确定",
        center: true,
        showClose: false,
        lockScroll: false,
        callback: action => {
          this.isYEditing(1)
        }
      });
    } else {
      // 各种提示
      this.variousPrompts()
    }
    this.$nextTick(() => {
      this.$parent.$refs.getNotice.getNotice(this.detail.user_id, "业务注意事项")
    })
  },
  methods: {
    isYEditing(type) {
      let datas = {
        porder_sn: this.porder_sn,
        is_y_editing: type
      }
      this.$store.dispatch('isYEditing', datas)
      this.variousPrompts()
    },
    // 各种提示
    variousPrompts() {
      let str = ''
      let num = 1
      if (!this.list.every(item => item.inSale == false)) {
        str += `<p>${num}:当前配送单有配送单相关售中问题产品未处理完成，装箱时请注意！！！</p>`
        num++
      }
      if (this.detail.coPorder != false || this.detail.co_porder_sn) {
        str += `<p style='color:red'>${num}:当前配送单客户标记了自主集运，请与客户确认具体集运需求</p>`
      }
      if (str) {
        this.$alert(str, '提示', {
          confirmButtonText: '确定',
          center: true,
          dangerouslyUseHTMLString: true,
          callback: action => {
          }
        });
      }
    },
    //全选
    allChecked() {
      this.$emit("allChecked");
    },
    // 配送单拆分
    distributionOrderSplit() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$parent.distributionOrderSplittingDialogVisible = true;
    },
    // 配送单-翻译提交
    submitTranslate(is_temp) {
      const isAmazonOrStockcrew = this.detail.is_amazon == 1 || (
        this.detail.external_inbound &&
        this.detail.external_inbound.warehouse_type === 'stockcrew'
      );
      let datas = {
        porder_sn: this.porder_sn,
        client_remark_translate:
          this.detail.porder_remark.client_remark_translate,
        list: [],
        is_temp,
      };
      for (let i = 0; i < this.list.length; i++) {
        // if (this.list[i].client_remark && this.list[i].y_remark == false) {
        //   this.$alert(this.list[i].order_sn + "客户商品备注未翻译", "提示", {
        //     confirmButtonText: "确定",
        //     center: true,
        //   });
        //   return false;
        // }
        datas.list.push({
          id: this.list[i].id,
          y_remark: this.list[i].y_remark,
        });
        // Amazon、Stockcrew 配送单的标签商品必须填写预计纳品数
        if (isAmazonOrStockcrew && this.list[i].porder_detail_tag != false && (!this.list[i].planned_num || Number(this.list[i].planned_num) === 0)) {
          this.$alert("当前配送单内有预计纳品数为空，请联系客户修改后重新提交。", "提示", {
            confirmButtonText: "确定",
            center: true,
            callback: action => {
            }
          });
          return false;
        }
      }
      this.$api.porderApi.submitTranslate(datas).then((res) => {
        this.$message.success(res.msg);
        setTimeout(() => {
          window.open("about:blank", "_top").close();
        }, 1000)
      });
    },
    //清空FBA数据(匹配及打印的数据)
    deleteMatchData() {
      let datas = { porder_sn: this.porder_sn };
      this.$api.porderApi.deleteMatchData(datas).then((res) => {
        this.$message.success(res.msg);
        this.$store.dispatch("porderDetail", datas);
        this.allChecked();
      });
    },
    //新建标签
    labelNumberAdd() {
      if (this.selectedList == false)
        return this.$message.error("未选择要添加标签的商品");
      if (this.selectedList.length > 1)
        return this.$message.error("只能单个商品添加标签");
      this.$parent.tagData = {
        porder_detail_id: "",
        type: "FBA",
        no: "",
        goods_no: "",
        num: this.selectedList[0].num,
        code_type: "CODE128",
        text_line_one: "",
        text_line_two: "",
        porder_detail_id: this.selectedList[0].id,
        isAdd: true,
      };
      this.$parent.$refs.tagEditing.dialogVisible = true;
    },
    //标签匹配
    tagMatching() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$parent.$refs.tagMatching.dialogVisible = true;
    },
    //修改提出数
    updatePorderNum() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: []
      }
      this.selectedList.forEach(item => {
        if (item.checked) {
          datas.list.push({
            porder_detail_id: item.id,
            num: item.num,
          })
        }
      })
      this.$api.porderApi.updatePorderNum(datas).then(res => {
        this.$message.success(res.msg)
        this.$parent.checked = false
        this.allChecked()
        this.$forceUpdate()
      })
    },
    // 打印清单
    printList() {
      this.$nextTick(() => {
        this.$print(this.$refs.printList)
      })
    },
    //标签删除
    deleteFbaSign() {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            order_detail_tag_id: [],
          };
          this.selectedList.forEach(item => {
            item.porder_detail_tag.forEach(tag => {
              datas.order_detail_tag_id.push(tag.id)
            })
          })
          this.$api.porderApi.deleteTag(datas).then((res) => {
            this.$message.success(res.msg);
            this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
          });
        })
        .catch(() => { });
    },
    // 退回临时保存
    toPorderTemp() {
      this.$confirm(
        this.$t("message.isReturnToTemporaryStorag"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            porder_sn: this.porder_sn,
          };
          this.$api.porderApi.toPorderTemp(datas).then((res) => {
            this.$message.success(res.msg);
            this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
          });
        })
        .catch(() => { });
    },
    //特殊客户标签上传
    specialClientMatch() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$parent.$refs.specialCustomerLabels.dialogVisible = true;
    },
    // 标签批量追加文本
    batchAppendTagText() {
      let datas = {
        porder_sn: this.porder_sn,
        text_line_four: 'Made in China',
        porder_detail_tag_id_set: [],
        is_replace: 1
      }
      this.list.forEach(item => {
        if (item.checked) {
          item.porder_detail_tag.forEach(tags => {
            datas.porder_detail_tag_id_set.push(tags.id)
          })
        }
      })
      this.$api.porderApi.batchAppendTagText(datas).then((res) => {
        this.$message.success(res.msg)
        this.list.forEach(item => {
          if (item.checked) {
            item.porder_detail_tag.forEach(tags => {
              tags.text_line_four = datas.text_line_four
            })
          }
        })
        this.$forceUpdate()
      })
    },
    // 标签批量追加订单后四位
    batchAppendTagPorder(num) {
      let Ptext = ''
      if (num) {
        let text = this.porder_sn.split('-')[0]
        Ptext = text.substr(text.length - num)
      } else {
        Ptext = this.porder_sn
      }
      let datas = {
        porder_sn: this.porder_sn,
        text_line_four: Ptext,
        porder_detail_tag_id_set: []
      }
      this.list.forEach(item => {
        if (item.checked) {
          item.porder_detail_tag.forEach(tags => {
            datas.porder_detail_tag_id_set.push(tags.id)
          })
        }
      })
      this.$api.porderApi.batchAppendTagText(datas).then((res) => {
        this.$message.success(res.msg)
        this.list.forEach(item => {
          if (item.checked) {
            item.porder_detail_tag.forEach(tags => {
              tags.text_line_four = tags.text_line_four + '' + datas.text_line_four
            })
          }
        })
        this.$forceUpdate()
      })
    },
    //标签批量修改条码格式
    batchModifyCodeType() {
      let data = {
        porder_sn: this.porder_sn,
        porder_detail_tag_id_set: [],
      }
      this.list.forEach(item => {
        if (item.checked) {
          item.porder_detail_tag.forEach(tags => {
            data.porder_detail_tag_id_set.push(tags.id)
          })
        }
      })
      if (data.porder_detail_tag_id_set == false) return this.$message.error('请选择要修改的订单')
      this.$parent.$refs.batchModifyCodeType.setData(data)
    },
    //强制商品编码覆盖第一行文本
    batchGoodsNoCoverTextOne() {
      let data = {
        porder_sn: this.porder_sn,
        porder_detail_tag_id_set: [],
      }
      this.list.forEach(item => {
        if (item.checked) {
          item.porder_detail_tag.forEach(tags => {
            data.porder_detail_tag_id_set.push(tags.id)
          })
        }
      })
      if (data.porder_detail_tag_id_set == false) return this.$message.error('请选择要修改的订单')
      this.$api.porderApi.batchGoodsNoCoverTextOne(data).then((res) => {
        this.$message.success(res.msg);
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
      });
    },
    //新增服务单
    addServiceOrder() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        porder_sn: this.porder_sn,
        porder_detail_ids: []
      }
      this.selectedList.forEach(item => {
        if (item.option != null && item.option != false) {
          datas.porder_detail_ids.push(item.id)
        }
      })
      if (datas.porder_detail_ids.length == 0)
        return this.$message.error('无可新增服务单的商品，请选择有附加服务的商品后新增服务单');
      this.$parent.$refs.createServiceOrder.fba_name = this.detail.fba_name
      this.$parent.$refs.createServiceOrder.optionServicePreview(datas)
      this.$parent.$refs.createServiceOrder.dialogVisible = true
    },
    //
    addGoods() {
      this.$parent.$refs.addGoods.open()
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let ids = []
      this.selectedList.forEach(item => {
        ids.push(item.order_detail_id)
      })
      this.$parent.$refs.inSalePreview.storePreview(ids)
    },
    // 预设任务
    createPresetTask() {
      let ids = []
      this.selectedList.forEach(item => {
        ids.push(item.id)
      })
      this.$parent.$refs.presetTask.typeList = ids == false ? [8] : [4, 5, 6, 8]
      this.$parent.$refs.presetTask.dialogVisible = true
    },
  },
};
</script>
<style lang='scss' scoped>
.operate {
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;

  .el-button {
    margin-left: 7px;
    padding: 7px 5px;
  }
}
</style>
